<template>
    <div class="fill-height d-flex">

        <v-expand-x-transition>
            <div class="px-2 fill-height of-y flex-grow-1 flex-equal" style="max-width: 35%">
                <template v-for="user in filteredUsers">
                    <div class="pa-2">
                        <v-card
                                class="d-flex align-center"
                                :key="user._id"
                                @click.self="$store.state.ref.users.selected = $store.state.ref.users.selected === user ? null : user"
                                :raised="$store.state.ref.users.selected === user"
                                hover
                        >
                            <div class="ml-2" @click.self="$store.state.ref.users.selected = $store.state.ref.users.selected === user ? null : user">
                                <template v-if="$store.state.ref.users.selected === user">
                                    <v-icon color="primary">mdi-check-circle</v-icon>
                                </template>
                                <template v-else>
                                    <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                                </template>
                            </div>

                            <div class="subtitle-1 font-weight-light flex-grow-1 flex-equal pa-2 text-truncate" @click.self="$store.state.ref.users.selected = $store.state.ref.users.selected === user ? null : user">
                                {{user.name}}
                            </div>


                            <div v-if="user.adminSiteId !== $store.state.curSiteId" class="pr-3">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-icon
                                                v-on="on"
                                        >
                                            mdi-shield-alert
                                        </v-icon>
                                    </template>
                                    Limited Access
                                </v-tooltip>

                            </div>

                            <!--                            <div class="body-2 font-weight-light pa-2 d-flex align-center" @click.self="$store.state.ref.users.selected = $store.state.ref.users.selected === user ? null : user">-->
                            <!--                                <app-outlined-chip-->
                            <!--                                        v-if="selectedTeam"-->
                            <!--                                        :label="`${employeesByTeam[user._id] ? employeesByTeam[user._id].length : 0}`"-->
                            <!--                                        icon="mdi-account"-->
                            <!--                                        color="primary"-->
                            <!--                                />-->
                            <!--                                <app-outlined-chip-->
                            <!--                                        v-else-->
                            <!--                                        :label="`${employeesByTeam[user._id] ? employeesByTeam[user._id].length : 0} Employee${employeesByTeam[user._id] && employeesByTeam[user._id].length === 1 ? '' : 's'}`"-->
                            <!--                                        icon="mdi-account"-->
                            <!--                                        color="primary"-->
                            <!--                                />-->
                            <!--                            </div>-->
                        </v-card>
                    </div>
                </template>
            </div>
        </v-expand-x-transition>

        <v-slide-x-reverse-transition>
            <div v-if="selectedUser" class="fill-height" style="width: 65%">
                <app-user-side-bar
                        :selected-user="selectedUser"
                        ref="sidebar"
                        @checkSelected="checkSelectedUserTab"
                />
            </div>
        </v-slide-x-reverse-transition>



<!--        <teleport to="#navBar">-->
<!--            <div class="text-h5">-->
<!--                System Admins-->
<!--            </div>-->
<!--        </teleport>-->
<!--        <div style="width: 300px" class="flex-shrink-0 white-back d-flex">-->
<!--            <app-list-->
<!--                    class="flex-grow-1"-->
<!--                    @input="con.log('INPUT', $event)"-->
<!--                    v-model="$store.state.ref.users.selected"-->
<!--                    :items="users"-->
<!--                    :multiple="false"-->
<!--                    headline-key="name"-->
<!--                    sub-line-key="username"-->
<!--                    item-key="_id"-->
<!--                    :show-check-boxes="true"-->
<!--                    :return-object="true"-->
<!--            >-->
<!--                <template #header>-->
<!--                    <div class="pt-2 px-2">-->
<!--                        <v-btn-->
<!--                                small-->
<!--                                block-->
<!--                                class="pa-0"-->
<!--                                color="secondary"-->
<!--                                text-->
<!--                                @click="showAddUser = true"-->
<!--                        >-->
<!--                            <v-icon>mdi-plus</v-icon>-->
<!--                            Add User-->
<!--                        </v-btn>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </app-list>-->
<!--            <v-divider vertical></v-divider>-->
<!--        </div>-->
<!--        <div class="flex-grow-1 pa-2">-->
<!--            <v-scroll-x-reverse-transition hide-on-leave>-->
<!--                <v-card v-if="!userChanged && $store.state.ref.users.selected" width="400">-->
<!--                    <v-card-title>-->
<!--                        {{$store.state.ref.users.selected.name}}-->
<!--                    </v-card-title>-->
<!--                    <v-card-text>-->
<!--&lt;!&ndash;                        <div class="flex-grow-1 flex-equal">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div>&ndash;&gt;-->
<!--&lt;!&ndash;                                Last Login: {{ value.lastLogin ? format(value.lastLogin, 'iiii do MMMM yyyy')  : 'None' }}&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                            <div>&ndash;&gt;-->
<!--&lt;!&ndash;                                Locked Status: {{ value.locked && value.locked.status ? `Locked` : "Unlocked" }}&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                            <div>&ndash;&gt;-->
<!--&lt;!&ndash;                                Failed Attempts: {{ value.locked && value.locked. ? `Locked` : "Unlocked" }}&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        <app-user-modify :user="$store.state.ref.users.selected"/>-->
<!--                    </v-card-text>-->
<!--                </v-card>-->
<!--            </v-scroll-x-reverse-transition>-->
<!--        </div>-->
        <app-user-create :shown.sync="$store.state.ref.users.showAdd" v-if="$store.state.ref.users.showAdd" @input="userAdded" />
    </div>
</template>

<script>

import {mapGetters} from "vuex";
import AppList from "@/components/Shared/AppList/AppList";
import AppUserCreate from "@/components/Users/AppUserCreate";
import AppUserModify from "@/components/Users/AppUserModify";
import {nameSort} from "@/core/codeFunctions";
import AppUserSideBar from "@/components/Users/AppUserSideBar";

export default {
    components: {AppUserSideBar, AppUserModify, AppUserCreate, AppList},
    data() {
        return {
            con: console,
            showAddUser: false,
            userChanged: false
        }
    },
    watch: {
        "$store.state.ref.users.selected"() {
            this.userChanged = true;
            this.$nextTick(() => {
                this.userChanged = false;
            })
        },
        "$store.state.ref.users.tabIndex"() {
            this.checkSelectedUserTab()
        }
    },
    created() {
        this.users.on('deleted', this.deselectDeleted)
    },
    beforeUnmount() {
        this.users.off('deleted', this.deselectDeleted)
    },
    mounted() {
        this.checkSelectedUserTab();
    },
    methods: {
        userAdded(user) {
            this.selectUser(user)
            this.checkSelectedUserTab();
        },
        selectUser(user) {
            this.$store.state.ref.users.selected = user
        },
        deselectDeleted(delObj) {
            if (this.$store.state.ref.users.selected === delObj)
                this.$store.state.ref.users.selected = null
        },
        checkSelectedUserTab() {
            if (
                    this.selectedUser && (
                            (this.$store.state.ref.users.tabIndex === 0 && this.selectedUser.disabledSiteIds.includes(this.$store.state.curSiteId))
                            || (this.$store.state.ref.users.tabIndex === 1 && !this.selectedUser.disabledSiteIds.includes(this.$store.state.curSiteId))
                    )
            ) {
                this.$store.state.ref.users.selected = null;
            }
        },
    },


    computed: {
        ...mapGetters(['users']),
        selectedUser() {
            return this.$store.state.ref.users.selected
        },
        filteredUsers() {
            return this.users.filter((user) => {
                if (this.$store.state.ref.users.tabIndex === 0 && user.disabledSiteIds.includes(this.$store.state.curSiteId))
                    return false
                if (this.$store.state.ref.users.tabIndex === 1 && !user.disabledSiteIds.includes(this.$store.state.curSiteId))
                    return false
                if (this.$store.state.ref.users.filterStr && !JSON.parse(JSON.stringify(user).toLowerCase().includes((this.$store.state.ref.users.filterStr || '').toLowerCase())))
                    return false
                return true
            })
                    .sort(nameSort)
        },
    },
}
</script>

<style scoped>

</style>